/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
export const fetchUser = (userId) => {
  let url = `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/user/fetch?user_id=${userId}`
  let headers = {
    'x-api-key': process.env.REACT_APP_X_API_KEY
  }

  return new Promise((resolve, reject) => {
    fetch(url, {headers: headers, method: 'GET', mode: 'cors'})
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          resolve(json.user)
        } else {
          let error = "Something went wrong"
          if (json && json.error) {
            error = json.error.message
          }
          reject(error)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const sendReferral = (source, to, from = '') => {
  let url = `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/referral/send`
  let params = {source, to, from}

  return new Promise((resolve, reject) => {
    fetch(url, {method: 'POST', mode: 'cors', body: JSON.stringify(params)})
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          resolve(json.data || json.result)
        } else {
          let error = "Something went wrong"
          if (json && json.error) {
            error = json.error.message
          }
          reject(error)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
